import { TopErrorCodesDaily } from "../Charts/TopErrorCodesDaily";

export function DailyDeclinesChart() {
  return (
    <TopErrorCodesDaily
      title="Daily declines"
      description="Number of declined payments per day."
    />
  );
}
